"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.computePremium = exports.buildTermKey = void 0;
var _constants = require("./constants");
var buildTermKey = exports.buildTermKey = function buildTermKey(faceValue, term) {
  var value = '';

  // B1: coverage $200,000 – $999,999
  if (faceValue < 1000000) {
    value += 'A';
    // B2: coverage $1,000,000 – $2,999,999
  } else if (faceValue < 3000000) {
    value += 'B';
    // B3: coverage $3,000,000+
  } else {
    value += 'C';
  }
  if (term === 10) {
    value += '1';
  } else if (term === 20) {
    value += '2';
  } else {
    value += '3';
  }
  return value;
};
var computePremium = exports.computePremium = function computePremium(faceValue, rate) {
  var scaledFaceValue = faceValue / 1000 * parseFloat(rate, 10);
  return Math.round((scaledFaceValue + _constants.SERVICE_FEE) * _constants.EFT_MULTIPLE);
};
var _default = exports["default"] = {
  buildTermKey: buildTermKey,
  computePremium: computePremium
};